/**
 * 日時変換ユーティリティクラス
 */
export default class DateTimeUtil {
  /**
   * UTC時刻をJST時刻に変換する（+9時間）
   */
  public static utcToJst(utcUnixtime: string): Date {
    const utcDate = new Date(utcUnixtime);
    const jstOffsetMs = 9 * 60 * 60 * 1000;
    return new Date(utcDate.getTime() + jstOffsetMs);
  }

  /**
   * DateをISO8601形式の文字列に変換する（YYYY-MM-DDTHH:mm:ss+09:00）
   */
  public static toIso8601(date: Date): string {
    const yyyy = date.getUTCFullYear();
    const mm = String(date.getUTCMonth() + 1).padStart(2, "0");
    const dd = String(date.getUTCDate()).padStart(2, "0");
    const hh = String(date.getUTCHours()).padStart(2, "0");
    const min = String(date.getUTCMinutes()).padStart(2, "0");
    const ss = String(date.getUTCSeconds()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}+09:00`;
  }

  /**
   * UTCをJST形式のISO8601文字列に変換する
   */
  public static utcUnixtimeToJstIso8601(utcUnixtime: string): string {
    const jstDate = DateTimeUtil.utcToJst(utcUnixtime);
    return DateTimeUtil.toIso8601(jstDate);
  }
}